import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { ChildItemsContainer, TitleSummary } from '../../style';

export const LoopComponent = ({ field, parents = [], renderFields, readOnly, reloadData }) => {
  return (
    <Row style={{ margin: '20px 0px' }}>
      <Col md={24}>
        <TitleSummary level={5}>{field.label}</TitleSummary>
      </Col>
      <Col md={24} style={{ paddingLeft: '3%' }}>
        {field?.value?.map((item, itenIndex) => {
          const itemParents = [...parents, { idInput: field.idInput, index: itenIndex }];
          return item?.map((data) => {
            return (
              <ChildItemsContainer>
                <Col md={24}>
                  <ul>
                    <li style={{ listStyle: 'circle' }}>
                      <span style={{ fontSize: '15px', fontWeight: 'bold' }}>
                        <p>
                          {field.label} {+data.page + 1}
                        </p>
                      </span>
                    </li>
                  </ul>
                </Col>
                {renderFields({ fields: data.fields, parents: itemParents, renderFields, readOnly, reloadData })}
              </ChildItemsContainer>
            );
          });
        })}
      </Col>
    </Row>
  );
};

LoopComponent.propTypes = {
  field: PropTypes.object.isRequired,
  parents: PropTypes.array,
  renderFields: PropTypes.func,
  reloadData: PropTypes.func,
  readOnly: PropTypes.bool,
};
